export default "__VITE_ASSET__rO5yJrhL__"